import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import webservice from '../common/Webservice';
import {Button, ColumnInformation, joinClassNames, SegmentedButton, Table, TableSorter, TableSorterField, TableSorterInformation} from "@utahdts/dts-react-common";
import {iconCarretRight, iconFilter} from '../common/Icon';
import {footerNotice, formatAmount, formatPriority, MEDIA_SIZES, prioritySorting} from "../misc/Shared";
import clone from 'clone';
import Media from "react-media";
import {Link} from 'react-router-dom';
import IssueDetail from "./IssueDetail";
import {isEmpty} from "lodash";
import {cookies, createCookie, readCookie} from "../misc/Cookies";

const propTypes = {
	currentCobiId:  PropTypes.number,

	currentIssueKey: PropTypes.number,

	currentTab:  PropTypes.string,

	currentYear:  PropTypes.number,

	draft: PropTypes.bool,

	history: PropTypes.object.isRequired,
};

const defaultProps = {
};

// Props connected to the store
const mapStateToProps = state => ({
	currentTab: state.app.currentTab,
	currentIssueKey: state.app.currentIssueKey,
	currentCobiId: state.app.currentCobiId,
	currentYear: state.app.currentYear,
	draft: state.app.draft
});

class Issues extends React.Component {
	constructor(props) {
		super(props);

		// Different Show Amount types have different columns! but to the user they are the same title. So switching
		// tables causes column sort to change, but it shouldn't... so need to pretend that the columns are the same
		// for sorting.
		// * when Show Amount changes, need to create a brand new table even if going back to an already created Show

		// * Amount table so that the sort order gets reset
		this.tableVersion = 1;

		// * columns that are the same between Show Amount types
		const commonShowAmountColumns = ['itemPriorityOneTime', 'itemPriorityOngoing', 'itemName'].map(item => ({field: item, cookie:item}));

		// * encode to cookie
		this.showAmountColumnMap = {
			request: [
				...commonShowAmountColumns,
				{field: 'requestOneTime', cookie: 'oneTime'},
				{field: 'requestOngoing', cookie: 'ongoing'},
			],
			priority: [
				...commonShowAmountColumns,
				{field: 'priorityOneTime', cookie: 'oneTime'},
				{field: 'priorityOngoing', cookie: 'ongoing'},
			],
			appropriation: [
				...commonShowAmountColumns,
				{field: 'appropriationOneTime', cookie: 'oneTime'},
				{field: 'appropriationOngoing', cookie: 'ongoing'},
			],
		};

		const issuesSortJSON = readCookie(cookies.issuesSort);
		const issueSortOrder = issuesSortJSON ? JSON.parse(issuesSortJSON) : {showAmount: 'request', sortField: null, sortDirection: 'ascending'};
		issueSortOrder.showAmount = issueSortOrder.showAmount || 'request';
		issueSortOrder.sortDirection = issueSortOrder.sortDirection || 'ascending';
		issueSortOrder.sortField = this.cookieFieldToSort(issueSortOrder.showAmount, issueSortOrder.sortField || 'itemName');

		this.state = {
			busy: true,
			content: undefined,
			filterValues: {},
			hideContent: false,
			issues: [],
			issuesFiltered: [],
			issueSortOrder,
			issuesTotals: {},
			otherIssues: [],
			sessions: [],
			showActionItems: true,
			showFilters: true,
			showItems: true,
			showZeros: false,
			sortByMobile: 'itemName',
		};

		this.getIssue = this.getIssue.bind(this);
		this.setContent = this.setContent.bind(this);
		this.getContent = this.getContent.bind(this);

		this.getContent();

		const itemPriorityOneTimeSort = new TableSorterField('itemPriorityOneTime', TableSorter.SORT.CUSTOM, TableSorter.DIRECTION.ASCENDING, prioritySorting);
		const itemPriorityOngoingSort = new TableSorterField('itemPriorityOngoing', TableSorter.SORT.CUSTOM, TableSorter.DIRECTION.ASCENDING, prioritySorting);
		const itemNameSort = new TableSorterField('itemName', TableSorter.SORT.TEXT, TableSorter.DIRECTION.ASCENDING);
		const requestOneTimeSort = new TableSorterField('requestOneTime', TableSorter.SORT.NUMBER, TableSorter.DIRECTION.ASCENDING);
		const requestOngoingSort = new TableSorterField('requestOngoing', TableSorter.SORT.NUMBER, TableSorter.DIRECTION.ASCENDING);
		const priorityOneTimeSort = new TableSorterField('priorityOneTime', TableSorter.SORT.NUMBER, TableSorter.DIRECTION.ASCENDING);
		const priorityOngoingSort = new TableSorterField('priorityOngoing', TableSorter.SORT.NUMBER, TableSorter.DIRECTION.ASCENDING);
		const appropriationOneTimeSort = new TableSorterField('appropriationOneTime', TableSorter.SORT.NUMBER, TableSorter.DIRECTION.ASCENDING);
		const appropriationOngoingSort = new TableSorterField('appropriationOngoing', TableSorter.SORT.NUMBER, TableSorter.DIRECTION.ASCENDING);

		const issueNameSort = new TableSorterField('issueName', TableSorter.SORT.TEXT, TableSorter.DIRECTION.ASCENDING);
		const locationSort = new TableSorterField('sortName', TableSorter.SORT.TEXT, TableSorter.DIRECTION.ASCENDING);


		this.columns = [
			new ColumnInformation({
				title: '1x',
				field: 'itemPriorityOneTime',
				thClassName: 'hidden-mobile atid_table_header',
				tableSorterInformation: new TableSorterInformation([itemPriorityOneTimeSort, itemPriorityOngoingSort, itemNameSort]),
				tdCallback: (columnInfo, objectData) => (
					<td key={columnInfo.field ? columnInfo.field : columnInfo.key} className="hidden-mobile">{formatPriority(objectData[columnInfo.field])}</td>),
				filter: false
			}),
			new ColumnInformation({
				title: 'Ong',
				field: 'itemPriorityOngoing',
				thClassName: 'hidden-mobile atid_table_header',
				tableSorterInformation: new TableSorterInformation([itemPriorityOngoingSort, itemPriorityOneTimeSort, itemNameSort]),
				tdCallback: (columnInfo, objectData) => (
					<td key={columnInfo.field ? columnInfo.field : columnInfo.key} className="hidden-mobile">{formatPriority(objectData[columnInfo.field])}</td>),
				filter: false
			}),
			new ColumnInformation({
				title: 'Description',
				field: 'itemName',
				thClassName: 'text-left hidden-mobile atid_table_header',
				tableSorterInformation: new TableSorterInformation([itemNameSort, itemPriorityOneTimeSort, itemPriorityOngoingSort]),
				tdCallback: (columnInfo, objectData) => {
					const session = this.state.sessions.filter(session => session.sessionCode === objectData.sessionCode)[0];
					return <td key={columnInfo.field ? columnInfo.field : columnInfo.key} className="text-left description">{this.getPriorityMobile(objectData)} {objectData[columnInfo.field]} {session ? <span className={"badge " + session.color}>{session.sessionCode}</span> : undefined}</td>},
				filterCallback: (filterList, filterValue) =>  this.setState({ issuesTotals: this.getTotals(filterList), issuesFiltered: filterValue ? filterList : [], filterValues: { itemName: filterValue } })
	}),
			new ColumnInformation({
				title: 'One-Time',
				field: 'requestOneTime',
				filter: false,
				thClassName: 'hidden-mobile atid_table_header',
				tdClassName: 'hidden-mobile',
				tableSorterInformation: new TableSorterInformation([requestOneTimeSort, requestOngoingSort]),
				tdCallback: (columnInfo, objectData) => (
					<td key={columnInfo.field ? columnInfo.field : columnInfo.key}
						className={this.state.issueSortOrder.showAmount === 'request' ? joinClassNames('hidden-mobile', objectData.itemName === 'Total' ? 'atid_totals_one-time' : '') : 'hidden-mobile hidden'}>
						{formatAmount(objectData[columnInfo.field], 0, '$', undefined, true)}</td>),
			}),
			new ColumnInformation({
				title: 'Ongoing',
				field: 'requestOngoing',
				filter: false,
				thClassName: 'hidden-mobile atid_table_header',
				tdClassName: 'hidden-mobile',
				tableSorterInformation: new TableSorterInformation([requestOngoingSort, requestOneTimeSort]),
				tdCallback: (columnInfo, objectData) => (
					<td key={columnInfo.field ? columnInfo.field : columnInfo.key}
						className={this.state.issueSortOrder.showAmount === 'request' ? joinClassNames('hidden-mobile', objectData.itemName === 'Total' ? 'atid_totals_ongoing' : '') : 'hidden-mobile hidden'}>
						{formatAmount(objectData[columnInfo.field], 0, '$', undefined, true)}</td>),
			}),
			new ColumnInformation({
				title: 'One-Time',
				field: 'priorityOneTime',
				filter: false,
				thClassName: 'hidden atid_table_header',
				tdClassName: 'hidden',
				tableSorterInformation: new TableSorterInformation([priorityOneTimeSort, priorityOngoingSort]),
				tdCallback: (columnInfo, objectData) => (
					<td key={columnInfo.field ? columnInfo.field : columnInfo.key}
						className={this.state.issueSortOrder.showAmount === 'priority' ? joinClassNames('hidden-mobile', objectData.itemName === 'Total' ? 'atid_totals_one-time' : '') : 'hidden-mobile hidden'}>
						{formatAmount(objectData[columnInfo.field], 0, '$', undefined, true)}</td>),
			}),
			new ColumnInformation({
				title: 'Ongoing',
				field: 'priorityOngoing',
				filter: false,
				thClassName: 'hidden atid_table_header',
				tdClassName: 'hidden',
				tableSorterInformation: new TableSorterInformation([priorityOngoingSort, priorityOneTimeSort]),
				tdCallback: (columnInfo, objectData) => (
					<td key={columnInfo.field ? columnInfo.field : columnInfo.key}
						className={this.state.issueSortOrder.showAmount === 'priority' ? joinClassNames('hidden-mobile', objectData.itemName === 'Total' ? 'atid_totals_ongoing' : '') : 'hidden-mobile hidden'}>
						{formatAmount(objectData[columnInfo.field], 0, '$', undefined, true)}</td>),
			}),
			new ColumnInformation({
				title: 'One-Time',
				field: 'appropriationOneTime',
				filter: false,
				thClassName: 'hidden atid_table_header',
				tdClassName: 'hidden',
				tableSorterInformation: new TableSorterInformation([appropriationOneTimeSort, appropriationOngoingSort]),
				tdCallback: (columnInfo, objectData) => (
					<td key={columnInfo.field ? columnInfo.field : columnInfo.key}
						className={this.state.issueSortOrder.showAmount === 'appropriation' ? joinClassNames('hidden-mobile', objectData.itemName === 'Total' ? 'atid_totals_one-time' : '') : 'hidden-mobile hidden'}>
						{formatAmount(objectData[columnInfo.field], 0, '$', undefined, true)}</td>),
			}),
			new ColumnInformation({
				title: 'Ongoing',
				field: 'appropriationOngoing',
				filter: false,
				thClassName: 'hidden atid_table_header',
				tdClassName: 'hidden',
				tableSorterInformation: new TableSorterInformation([appropriationOngoingSort, appropriationOneTimeSort]),
				tdCallback: (columnInfo, objectData) => (
					<td key={columnInfo.field ? columnInfo.field : columnInfo.key}
						className={this.state.issueSortOrder.showAmount === 'appropriation' ? joinClassNames('hidden-mobile', objectData.itemName === 'Total' ? 'atid_totals_ongoing' : '') : 'hidden-mobile hidden'}>
						{formatAmount(objectData[columnInfo.field], 0, '$', undefined, true)}</td>),
			})
		];

		this.otherIssuesColumns = [
			new ColumnInformation({
				title: 'Description',
				field: 'issueName',
				thClassName: 'text-left hidden-mobile atid_table_header',
				tableSorterInformation: new TableSorterInformation([issueNameSort, locationSort]),
				tdCallback: (columnInfo, objectData) => {
					return <td key={columnInfo.field ? columnInfo.field : columnInfo.key}><span onClick={() => this.getOtherItem(objectData)} className='link'>{objectData[columnInfo.field]}</span></td>;
				}
			}),
			new ColumnInformation({
				title: 'Location',
				field: 'location',
				thClassName: 'text-left hidden-mobile atid_table_header',
				tableSorterInformation: new TableSorterInformation([locationSort, issueNameSort]),
				tdCallback: (columnInfo, objectData) => {
					return (<Media query={MEDIA_SIZES.TABLET_NARROW_MAX_WIDTH} key={columnInfo.field ? columnInfo.field : columnInfo.key}>
						{matches =>
							matches ? (
								<td className="text-left description">
									<span className="mr-spacing-small location">Location:</span>{objectData['cobiId'] === this.props.currentCobiId ? objectData[columnInfo.field] : <Link
									to={`/${this.props.currentYear}/${objectData['cobiId']}/issues${this.props.draft ? '/draft' : ''}`}>{objectData[columnInfo.field]}</Link>}</td>
							) : (
								<td className="text-left description">{objectData['orgName'] ? objectData['orgName'] : this.formatOtherIssuesLocation(objectData)}</td>
							)
						}
					</Media>);
				}
			})
		];
	}

	componentDidUpdate(prevProps) {
		if ((prevProps.currentCobiId !== this.props.currentCobiId) || (this.props.currentYear !== prevProps.currentYear)) {
			window.scroll({top: 0, left: 0});
			this.setState({ busy: true,	hideContent: false }, this.getContent);
		}
	}

	componentWillUnmount() {
		this.isCancelled = true;
	}

	getContent() {
		this.props.draft ?
			webservice.admin.tab.draft(this.props.currentCobiId, this.props.currentYear, this.props.currentTab).then(this.setContent)
			: webservice.public.tab.content(this.props.currentCobiId, this.props.currentYear, this.props.currentTab).then(this.setContent);
	}

	setContent(data) {
		const otherIssues = data.issueText.concat(data.relatedIssues).filter(issue => issue.isActive).map(issue => ({location: this.getOtherIssuesLocation(issue) ,...issue}));
		!this.isCancelled && this.setState({issues: data.issues, issuesTotals: this.getTotals(data.issues), content: data.text, busy: false, sessions: this.getSession(data), otherIssues: otherIssues });
	}

	getTotals(data) {
		data = clone(data);
		const amountOneTime = this.state.issueSortOrder.showAmount + 'OneTime';
		const amountOngoing = this.state.issueSortOrder.showAmount + 'Ongoing';
		const totals = data.length > 0 ? data.reduce((a, v) => ({
				[amountOneTime]: a[amountOneTime] + v[amountOneTime],
				[amountOngoing]: a[amountOngoing] + v[amountOngoing]
			})) : {
				[amountOneTime]: 0,
				[amountOngoing]: 0
			};
		totals.itemPriorityOneTime = 0;
		totals.itemPriorityOngoing = 0;
		totals.itemName = 'Total';
		return totals;
	}

	getIssue(issue) {
		this.props.history.push(`/${this.props.currentYear}/${this.props.currentCobiId}/issues/${issue.itemKey}${this.props.draft ? '/draft' : ''}`);
	}

	getOtherItem(item) {
		this.props.history.push(`/${item.sessionFiscalYear}/${item.cobiId}/issues/${item.issueId}/text${this.props.draft ? '/draft' : ''}`);
	}

	getSession(data) {
		let sessions = [];
		data.issues.forEach(issue => sessions.filter(session => session.sessionCode === issue.sessionCode).length > 0 || issue.sessionCode === 'GS' ? undefined : sessions.push({
				sessionCode: issue.sessionCode,
				session: issue.session,
				color: 'background--color' + sessions.length
			}));
		return sessions;
	}

	getOtherIssuesLocation(issue) {
		return issue['programName'] ? issue['programName'] : issue['lineItemName'] ? issue['lineItemName'] : issue['orgName'];
	}

	sortTableMobile(issues) {
		const sortValue = this.state.sortByMobile;
		let sortFunction;
		if (sortValue === 'itemName') {
			sortFunction = (a, b) => {
				a = a[sortValue];
				b = b[sortValue];
				return a === b ? 0 : a === null ? -1 : a.localeCompare(b);
			};
		} else {
			sortFunction = (a, b) => {
				a = a[sortValue];
				b = b[sortValue];
				a = a === -10 ? a : a <= 0 ? Infinity : a;
				b = b === -10 ? b : b <= 0 ? Infinity : b;
				return a === b ? 0 : a === null ? -1 : b === null ? 1 : a - b;
			};
		}
		issues.sort(sortFunction);
	}

	formatOtherIssuesLocation(issue) {
		let formatLocation;
		if (issue['orgTypeName'] === 'lineItem') {
			formatLocation = <span>{issue['agencyName'] + ' » '} <Link to={`/${this.props.currentYear}/${issue['cobiId']}/issues${this.props.draft ? '/draft' : ''}`}>{issue['lineItemName']}</Link></span>;
		} else if (issue['orgTypeName'] === 'program'){
			formatLocation = <span>{issue['agencyName'] + ' » ' + issue['lineItemName'] + ' » '} <Link to={`/${this.props.currentYear}/${issue['cobiId']}/issues${this.props.draft ? '/draft' : ''}`}>{issue['programName']}</Link></span>;
		}
		return formatLocation;
	}

	getPriorityMobile(issue) {
		return (<Media
			query={MEDIA_SIZES.TABLET_NARROW_MAX_WIDTH}
			render={() => (<span className="priority-mobile">{this.state.sortByMobile === 'itemPriorityOngoing' ? formatPriority(issue['itemPriorityOngoing']) : formatPriority(issue['itemPriorityOneTime'])}</span>)}
		/>);
	}

	sortFieldToCookie = (showAmount, field) => this.showAmountColumnMap[showAmount].find(data => data.field === field).cookie;

	cookieFieldToSort = (showAmount, cookieField) => this.showAmountColumnMap[showAmount].find(data => data.cookie === cookieField).field;

	setSortOrder = (showAmount, sortField, sortDirection, callback) => {
		const common = {
			showAmount: showAmount || this.state.issueSortOrder.showAmount,
			sortDirection: sortDirection || this.state.issueSortOrder.sortDirection,
		};

		// if changing showamount then translate sortField to new Show Amount type
		if (!sortField) {
			// what does sort order translate to
			const cookieSortOrder = this.sortFieldToCookie(this.state.issueSortOrder.showAmount, this.state.issueSortOrder.sortField);

			// translate sort field to new showAmount
			sortField = this.cookieFieldToSort(showAmount, cookieSortOrder);
		}
		this.setState({issueSortOrder: {...common, sortField: sortField || this.state.issueSortOrder.sortField}}, callback);
		createCookie(cookies.issuesSort, JSON.stringify({...common, sortField:  this.sortFieldToCookie(showAmount, sortField || this.state.issueSortOrder.sortField)}));

		// force table to reload with new sort order defaults
		if (showAmount) {
			this.tableVersion++;
		}
	};

	render() {
		for (let i = 3; i < this.columns.length; i++) {
			if(this.columns[i].field === this.state.issueSortOrder.showAmount + 'OneTime' || this.columns[i].field === this.state.issueSortOrder.showAmount + 'Ongoing') {
				this.columns[i].thClassName = "hidden-mobile";
				this.columns[i].tdClassName = "hidden-mobile";
			} else {
				this.columns[i].thClassName = "hidden hidden-mobile";
				this.columns[i].tdClassName = "hidden hidden-mobile";
			}
		}

		const issues = !this.state.showZeros ? clone(this.state.issues).filter(issue => issue[this.state.issueSortOrder.showAmount + 'OneTime'] !== 0 || issue[this.state.issueSortOrder.showAmount + 'Ongoing'] !== 0) : clone(this.state.issues);

		if (window.innerWidth < 768) {
			this.sortTableMobile(issues);
			this.columns.forEach(column => delete column.tableSorterInformation);
		}

		return (
			this.props.currentIssueKey ? <IssueDetail history={this.props.history} /> : <React.Fragment>
				{this.state.content && <div dangerouslySetInnerHTML={{__html: this.state.content.tabHtml}}/>}
				{this.state.issues && <section className="mb-spacing fr-view">
					<div className={joinClassNames("collapsible-section", this.state.hideContent ? 'hidden' : '')}>
						<div className="clearfix collapsible-section__title">
							<h3 className="float-left">Funding Items</h3>
							<a href="#" onClick={(e) => {
								e.preventDefault();
								this.setState({showItems: !this.state.showItems});
							}} className="float-right mt-spacing-small atid_expand_carret">{iconCarretRight(this.state.showItems ? "rotate-ninety" : "")}</a>
						</div>
						<div className={this.state.showItems ? '' : 'visually-hidden'}>
							<Media
								query={MEDIA_SIZES.TABLET_NARROW_MAX_WIDTH}
								render={() => <a href="#" onClick={(e) => {
									e.preventDefault();
									this.setState({showFilters: !this.state.showFilters});
								}} className="collapsible-section__content block filter-toggle">Filters {iconFilter()}</a>}
							/>
							<div className={"collapsible-section__filters collapsible-section__content clearfix no-print " + (this.state.showFilters ? '' : 'visually-hidden')}>
								<SegmentedButton
									label="Show amount:"
									field="showAmount"
									className="flex-mobile float-left mtb-spacing-small full-mobile"
									value={this.state.issueSortOrder.showAmount}
									options={[
										{label: 'Requested', value: 'request'},
										{label: 'Prioritized', value: 'priority'},
										{label: 'Funded', value: 'appropriation'}
									]}
									onChange={(field, val) => {
										this.setSortOrder(val, undefined, undefined, () => this.setState({issuesTotals: this.getTotals(isEmpty(this.state.issuesFiltered) ? this.state.issues : this.state.issuesFiltered)}));
									}}
								/>
								<Media
									query={MEDIA_SIZES.TABLET_NARROW_MAX_WIDTH}
									render={() => (<SegmentedButton
										label="Sort by:"
										field="sortByMobile"
										className="flex-mobile float-left mtb-spacing-small full-mobile"
										value={this.state.sortByMobile}
										options={[
											{label: 'One-Time', value: 'itemPriorityOneTime'},
											{label: 'Ongoing', value: 'itemPriorityOngoing'},
											{label: 'Description', value: 'itemName'}
										]}
										onChange={(field, val) => this.setState({sortByMobile: val})}
									/>)}
								/>
								<div className="float-right mtb-spacing-small flex align-center atid_show_all">
									<span>{this.state.showZeros ? "Hide zero values" : "Show all"}</span>
									<label className="switch ml-spacing-small">
										<input
											type="checkbox"
											checked={this.state.showZeros}
											onChange={(e) => this.setState({showZeros: e.target.checked})}
										/>
										<span className="slider round"/>
									</label>
								</div>
								<Media
									query={MEDIA_SIZES.TABLET_NARROW_MAX_WIDTH}
									render={() => (<Button
										label="Clear filter"
										onClick={() => this.setState({
											filterValues: {
												itemName: undefined,
											}
										})}
										className="block mtb-spacing clear button light"
									/>)}
								/>
							</div>
							<Table
								key={`${this.state.issueSortOrder.showAmount}-${this.tableVersion}`}
								columns={this.columns}
								list={issues}
								className="issues"
								totals={window.innerWidth >= 768 ? this.state.issuesTotals : undefined}
								ajaxSpinner={this.state.busy}
								filters={this.state.showFilters}
								onRowClick={(issue) => this.getIssue(issue)}
								defaultSortField={(window.innerWidth >= 768 ? this.state.issueSortOrder.sortField : undefined)}
								defaultSortFieldDirection={this.state.issueSortOrder.sortDirection}
								filterValues={this.state.filterValues}
								onTableSorterSet={
									(sorter, column) => (
											sorter && column &&
											(this.state.issueSortOrder.sortField !== column.field ||
												this.state.issueSortOrder.sortDirection !== sorter.sortDirection)
										) &&
											this.setSortOrder(this.state.issueSortOrder.showAmount, column.field, sorter.sortDirection)
								}
							/>
							<Media
								query={MEDIA_SIZES.TABLET_NARROW_MAX_WIDTH}
								render={() => (<ul className="flex totals-mobile bold-text space-between">
									<li>Totals</li>
									<li className="one-time atid_totals_one-time">${formatAmount(this.state.issuesTotals[this.state.issueSortOrder.showAmount + 'OneTime'])}</li>
									<li className="ongoing atid_totals-ongoing">${formatAmount(this.state.issuesTotals[this.state.issueSortOrder.showAmount + 'Ongoing'])}</li>
								</ul>)}
							/>
						</div>
					</div>
					<div className={this.state.hideContent ? 'visually-hidden' : 'badge-legend  mb-spacing'}>
						{this.state.sessions.map((session, index) => (<span className={"badge " + session.color} key={index}>{session.sessionCode}</span>))}
						{this.state.sessions.length > 0 && <span className="italic-text mr-spacing">this item is part of a Special Session.</span>}
						<span className="italic-text"><strong>*</strong> this item is a reallocation.</span>
					</div>
					{this.state.otherIssues.length > 0 ? <div className={joinClassNames("collapsible-section", this.state.hideContent ? 'hidden' : '')}>
						<div className="clearfix collapsible-section__title">
							<h3 className="float-left">Other Action Items</h3>
							<a href="#" onClick={(e) => {
								e.preventDefault();
								this.setState({showActionItems: !this.state.showActionItems});
							}} className="float-right mt-spacing-small atid_expand_carret_other">{iconCarretRight(this.state.showActionItems ? "rotate-ninety" : "")}</a>
						</div>
						<div className={this.state.showActionItems ? '' : 'visually-hidden'}>
							<Table
								columns={this.otherIssuesColumns}
								list={this.state.otherIssues}
								className="issues issues-other"
								ajaxSpinner={this.state.busy}
								filters={true}
								trClassName="atid_row"
							/>
						</div>
					</div> : undefined}
					{footerNotice('mt-spacing-large')}
				</section>}
			</React.Fragment>
		);
	}
}

Issues.propTypes = propTypes;
Issues.defaultProps = defaultProps;

export default connect(mapStateToProps)(Issues);
